var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReference(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4 9.2H9.6V8H6.4V9.2ZM6.4 7.2H12V6H6.4V7.2ZM6.4 5.2H12V4H6.4V5.2ZM5.2 12C4.87 12 4.5875 11.8825 4.3525 11.6475C4.1175 11.4125 4 11.13 4 10.8V2.8C4 2.47 4.1175 2.1875 4.3525 1.9525C4.5875 1.7175 4.87 1.6 5.2 1.6H13.2C13.53 1.6 13.8125 1.7175 14.0475 1.9525C14.2825 2.1875 14.4 2.47 14.4 2.8V10.8C14.4 11.13 14.2825 11.4125 14.0475 11.6475C13.8125 11.8825 13.53 12 13.2 12H5.2ZM5.2 10.8H13.2V2.8H5.2V10.8ZM2.8 14.4C2.47 14.4 2.1875 14.2825 1.9525 14.0475C1.7175 13.8125 1.6 13.53 1.6 13.2V4H2.8V13.2H12V14.4H2.8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReference);
export default __webpack_public_path__ + "static/media/reference.1ba4272ef42917801bcb473cdf24ecc3.svg";
export { ForwardRef as ReactComponent };